import type { PriceDetailsQueryParams } from '@/scopes/common/infrastructure/price-details/api/types';
import { create } from 'zustand';
import { RoomsParticipantDistribution } from '@/domain/shared/types';

interface PriceDetailsState {
  transportType: string;
  accommodationId: number;
  duration: number;
  mealPlan: string;
  departureDate: string;
  participants: RoomsParticipantDistribution;
  setPriceDetailsQueryParams: (queryParams: PriceDetailsQueryParams) => void;
}

export const usePriceDetailsStore = create<PriceDetailsState>((set) => ({
  transportType: '',
  accommodationId: 0,
  duration: 0,
  mealPlan: '',
  departureDate: '',
  participants: [],
  setPriceDetailsQueryParams: ({ transportType, accommodationId, duration, mealPlan, departureDate, participants }) => {
    set(() => ({
      transportType,
      accommodationId,
      duration,
      mealPlan,
      departureDate,
      participants,
    }));
  },
}));
